export enum EnumOperator {
    MORE = "MORE",
    LESS = "LESS",
    EQUAL = "EQUAL",
    MOREQUAL = "MOREQUAL",
    LESSEQUAL = "LESSEQUAL",
}